import { style } from 'typestyle'
export const mr8 = style({ marginRight: '8px' })
